import { CloseOutlined, LeftOutlined } from '@ant-design/icons'
import { STYLED_VARIABLES } from "@cloudike/web_ui_components"
import { Spin } from "antd"
import styled from "styled-components"

export const SMainContent = styled.div`
  width: 100%;
  display: flex;
  padding: 0;
  position: relative;
  user-select: none;
  z-index: 18;
  align-items: center;
  height: calc(100vh - 75px);
`

export const SArrowBox = styled.button`
  display: flex;
  border: none;
  height: 48px;
  width: 48px;
  border-radius: 24px;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  background-color: transparent;
  outline: none;
  
  &.rotated {
    transform: rotate(180deg);
  }

  &:hover {
    background-color: #2A2A2AE5;
  }

  @media (min-width: ${STYLED_VARIABLES.BREAKPOINTS.TABLET}) {
    &:hover {
      background-color: #2A2A2AE5;
    }
  }
`

export const SArrowContainer = styled.div`
  width: 48px;
  display: flex;
  align-items: center;
  z-index: 1;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 20px;
  height: fit-content;

  &.right {
    left: unset;
    right: 20px;
  }

  &.hidden {
    opacity: 0;
    pointer-events: none;
  }
`

export const SFilePreview = styled.div`
  margin: auto;
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: center;
  max-width: 100%;
`

export const SIframe = styled.iframe`
  display: block;
  min-width: 100%;
  min-height: 100%;
  overflow: auto;
  overflow-y: scroll;
`

export const SFilePreviewIconBox = styled.div`
  width: 100px;
  height: 100px;
  border: 4px solid #fff;
  box-shadow: 0 4px 20px rgb(0 0 0 / 8%);
  border-radius: 4px;
  background-color: #ddd;
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 16px;  
`
export const SContentWrapper = styled.div<{ $isPublicLink?: boolean }>`
  height: 100%;
  width: 100%;
  flex: 1;
  display: flex;
  position: relative;
  justify-content: center;
  align-items: center;
  max-width: ${({ $isPublicLink }) => ($isPublicLink ? '100vw' : 'calc(100vw - var(--right-panel-width, 360px))')};
  margin: ${({ $isPublicLink }) => ($isPublicLink ? 'auto' : 'initial')};
  overflow: hidden;

  @media (max-width: ${STYLED_VARIABLES.BREAKPOINTS.TABLET}) {
    padding: 0;
  }

  @media (min-width: ${STYLED_VARIABLES.BREAKPOINTS.TABLET}) {
    position: relative;
  }
`

export const Img = styled.img`
  width: 100%;
  height: 100%;
  display: block;
  margin: 0;
  max-height: 100%;
  max-width: 100%;
  object-fit: contain;
  user-select: none;
    
  &.not-loaded {
    display: none;
  }
`

export const SFilesPreviewModalBox = styled.div`
  width: 100vw;
  height: 100%;
  position: fixed;
  display: flex;
  flex-direction: column;
  z-index: 17;
  top: 0;
  left: 0;
  user-select: text;
`

export const SHiddenImg = styled.img`
  display: none;
`

export const StyledSpinner = styled(Spin)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 48px;
  height: 48px;
`

export const StyledVideo = styled.video`
  display: block;
  margin: 0;
  user-select: none;
  object-fit: contain;
  max-width: 100%;
  max-height: 100%;
  
  &.not-loaded {
    &::-webkit-media-controls {
      visibility: hidden;
    }

    &::-webkit-media-controls-enclosure {
      visibility: visible;
    }
  }
`

export const SAudioContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const SCoverImage = styled.img`
  margin-bottom: 20px;
  width: 250px;
  height: 240px;
`

export const SOverlay = styled.div`
  z-index: 11;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #000;
`

export const SArrowIcon = styled(LeftOutlined)`
  color: #fff;
`

export const STopRow = styled.div`
  display: flex;
  align-items: center;
  height: 75px;
  padding: 0 24px;
  border-bottom: 1px solid #232323;
  background-color: #1F1F1F;
`

export const SFileName = styled.p`
  font-weight: 600;
  font-size: 16px;
  line-height: 21px;
  color: #FFFFFFD9;
`

export const STopLeft = styled.div`
  margin-left: 24px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  height: 100%;
`

export const STopRight = styled.div`
  margin-left: auto;
  display: flex;
  align-items: center;
  height: 100%;
  gap: 16px;
`

export const SCloseButton = styled(CloseOutlined)`
  margin-left: 40px;
  width: 32px;
  height: 32px;
  color: #fff;
  cursor: pointer;
`


